import { useParams } from "react-router-dom";
import PageShell from "../components/PageShell";
import PortfolioFilter from "../components/PortfolioFilter";
import { portfolioContent } from "../data/siteData";

export default function PortfolioPage() {
  const { category } = useParams();
  const key = category || "all";
  const content = portfolioContent[key] || portfolioContent.all;
  const isBrand = key === "brand";
  const brandTopItems =
    isBrand && content.mode === "grid" ? content.images.slice(0, 6) : [];
  const brandFeatureItem =
    isBrand && content.mode === "grid" ? content.images[6] : null;
  const brandLeftBottomItems =
    isBrand && content.mode === "grid" ? content.images.slice(7, 11) : [];
  const brandRightBottomItem =
    isBrand && content.mode === "grid" ? content.images[11] : null;
  const mosaicItems = content.mode === "mosaic" ? content.images || [] : [];

  return (
    <PageShell pageClass="page-portfolio">
      <section className="container portfolio-container">
        <h1 className="page-title">Portfolio</h1>
        <PortfolioFilter />

        {content.mode === "mosaic" && (
          <>
            <div
              className={`portfolio-mosaic ${
                key === "all" ? "portfolio-mosaic-showcase" : ""
              }`}
            >
              {mosaicItems.map((image, index) => (
                <div
                  className={`mosaic-card ${
                    key === "all" ? `mosaic-card-${index + 1}` : ""
                  }`}
                  key={image}
                >
                  <img src={image} alt={`Portfolio item ${index + 1}`} />
                </div>
              ))}
            </div>
            {content.extras?.length > 0 && (
              <div className={`ui-strip ${key === "all" ? "ui-strip-tall" : ""}`}>
                {content.extras.map((image, index) => (
                  <div className="ui-strip-item" key={image}>
                    <img src={image} alt={`UI preview ${index + 1}`} />
                  </div>
                ))}
              </div>
            )}
          </>
        )}

        {content.mode === "columns" && (
          <>
            <div className="portfolio-hero-image">
              <img src={content.hero} alt="Graphic design hero" />
            </div>
            <div className="portfolio-graphic-grid">
              {content.columns.flat().map((image, index) => (
                <div
                  className={`graphic-grid-card graphic-grid-card-${index + 1}`}
                  key={image}
                >
                  <img src={image} alt={`Graphic design ${index + 2}`} />
                </div>
              ))}
            </div>
          </>
        )}

        {content.mode === "grid" && isBrand && (
          <div className="brand-showcase">
            <div className="brand-showcase-left">
              <div className="brand-top-small-grid">
                {brandTopItems.map((image, index) => (
                  <div className="portfolio-card brand-small-card" key={image}>
                    <img src={image} alt={`Brand item ${index + 1}`} />
                  </div>
                ))}
              </div>

              <div className="brand-left-bottom-grid">
                {brandLeftBottomItems.map((image, index) => (
                  <div
                    className="portfolio-card brand-left-bottom-card"
                    key={image}
                  >
                    <img src={image} alt={`Brand showcase ${index + 1}`} />
                  </div>
                ))}
              </div>
            </div>

            <div className="brand-showcase-right">
              {brandFeatureItem && (
                <div className="portfolio-card brand-feature-card">
                  <img src={brandFeatureItem} alt="Brand feature" />
                </div>
              )}

              {brandRightBottomItem && (
                <div className="portfolio-card brand-right-bottom-card">
                  <img src={brandRightBottomItem} alt="Brand showcase feature" />
                </div>
              )}
            </div>
          </div>
        )}

        {content.mode === "grid" && !isBrand && (
          <div
            className={`portfolio-grid ${isBrand ? "portfolio-brand-grid" : ""}`}
          >
            {content.images.map((image, index) => (
              <div
                className={`portfolio-card ${isBrand ? `brand-card brand-card-${index + 1}` : ""}`}
                key={image}
              >
                <img src={image} alt={`Portfolio item ${index + 1}`} />
              </div>
            ))}
          </div>
        )}

        {content.mode === "ui" && (
          <>
            <div className="ui-strip">
              {content.top.map((image, index) => (
                <div className="ui-strip-item" key={image}>
                  <img src={image} alt={`UI design ${index + 1}`} />
                </div>
              ))}
            </div>
            <h2 className="prototype-heading">Prototype</h2>
            <div className="portfolio-grid prototype-grid">
              {content.bottom.map((image, index) => (
                <div className="portfolio-card" key={image}>
                  <img src={image} alt={`Prototype ${index + 1}`} />
                </div>
              ))}
            </div>
          </>
        )}

        {content.mode === "video" && (
          <div className="video-grid">
            {content.videos.map((video, index) => (
              <div className="video-card" key={`${video}-${index}`}>
                <video controls preload="metadata">
                  <source src={video} type="video/mp4" />
                </video>
              </div>
            ))}
          </div>
        )}
      </section>
    </PageShell>
  );
}
